<template>
  <div>
    <el-button class="button" type="primary" @click="getDefault()">
      查询
    </el-button>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div class="search-left-top">
        <el-form-item label="关键词：">
          <el-input v-model="formInline.keyword"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="formInline.is_effect">
            <el-option
              v-for="item in is_effect"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <!-- 标题 -->
    <div class="title">
      <div>轮播关键词列表</div>
      <div>
        <el-button type="primary" @click="add">新增</el-button>
        <el-button type="primary" @click="setLbTime">设置时间</el-button>
      </div>
    </div>
    <el-table
      :data="lbKeywordData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="id" label="ID" align="center" width="150">
      </el-table-column>
      <el-table-column prop="keyword" label="关键词" align="center" width="150">
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" align="center">
      </el-table-column>
      <el-table-column label="删除时间" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.deleted_at != null">{{ scope.row.deleted_at }}</p>
          <p v-else>无</p>
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" align="center">
      </el-table-column>
      <el-table-column label="是否有效" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.is_effect == 1">有效</p>
          <p v-if="scope.row.is_effect == 0">无效</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row)">删除</el-button>
          <el-button
            type="text"
            v-if="scope.row.is_effect == 1"
            @click="isShelf(scope.row)"
            >关闭</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.is_effect == 0"
            @click="isShelf(scope.row)"
            >开启</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <!-- 轮播关键词编辑弹出框 -->
    <el-dialog
      :visible.sync="editLbKeywordVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="lbKeywordForm" label-width="180px">
        <el-form-item label="关键词：">
          <el-input
            type="text"
            v-model="lbKeywordForm.keyword"
            @input="change($event)"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editLbKeywordVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 设置轮播关键词时间弹出框 -->
    <el-dialog
      :visible.sync="editLbKeywordTimeVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTimeTitle"
      center
    >
      <el-form ref="ruleForm" :model="lbKeywordTimeForm" label-width="180px">
        <el-form-item label="关键词时间：">
          <el-input type="number" v-model="lbKeywordTimeForm.times"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveTimeEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editLbKeywordTimeVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/knowledgeApiConfig";
export default {
  data() {
    return {
      id: "",
      is_edit: false,
      editLbKeywordVisible: false,
      editLbKeywordTimeVisible: false,
      editTitle: "轮播关键词详情页",
      editTimeTitle: "设置轮播关键词时间",
      loading: false,
      formInline: {
        is_effect: "",
      },
      lbKeywordForm: {},
      lbKeywordTimeForm: {},
      lbKeywordData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      is_effect: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "有效",
        },
        {
          value: "0",
          label: "无效",
        },
      ],
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    getDefault() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        keyword: this.formInline.keyword,
        is_effect: this.formInline.is_effect,
      };
      http.get("/admin/keyword/tips/list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.lbKeywordData = res.data.data.data;
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    // 新增
    add() {
      this.is_edit = false;
      this.lbKeywordForm = {};
      this.editLbKeywordVisible = true;
    },
    // 编辑
    edit(row) {
      this.id = row.id;
      this.lbKeywordForm.keyword = row.keyword;
      this.is_edit = true;
      this.editLbKeywordVisible = true;
    },
    // 设置轮播时间
    setLbTime() {
      this.editLbKeywordTimeVisible = true;
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/keyword/tips/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 提交
    saveEdit() {
      if (this.is_edit == true) {
        let params = {
          keyword: this.lbKeywordForm.keyword,
        };
        http.put("/admin/keyword/tips/" + this.id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("修改成功");
            this.getDefault();
            this.editLbKeywordVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        let params = {
          keyword: this.lbKeywordForm.keyword,
        };
        http.post("/admin/keyword/tips", params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("新增成功");
            this.getDefault();
            this.editLbKeywordVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 提交轮播关键词时间
    saveTimeEdit() {
      let params = {
        times: this.lbKeywordTimeForm.times,
      };
      http.put("/admin/keyword/times/tips", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("轮播关键词时间设置成功");
          this.getDefault();
          this.editLbKeywordTimeVisible = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 上下架
    isShelf(row) {
      let that = this;
      if (row.is_effect == 1) {
        that
          .$confirm("确定要关闭吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("/admin/keyword/status/tips/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已关闭");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        that
          .$confirm("确定要开启吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("/admin/keyword/status/tips/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已开启");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 强制刷新input
    change() {
      this.$forceUpdate();
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
